<!-- 标准列表 -->
<template>
<div class='cm_list_container'>
  <div class="cm_list_heading">
    <h3>保密防护</h3>
    <span>您的位置： 保密防护</span>
  </div>
  <ul class="cm_list_content">
    <li>
      <h3>内蒙古自治区涉密信息系统集成资质</h3>
      <div class="cm_list_content_source">
        <span>来源：内蒙古自治区国家保密局</span>
        <span>2020-06-06</span>
      </div>
    </li>
  </ul>
  <div class="cm_list_pagination">
    <el-pagination
  background
  layout="prev, pager, next"
  :total="1000">
</el-pagination>
  </div>
</div>
</template>

<script>


export default {
components: {},
data() {
//这里存放数据
return {
  
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},

}
</script>
<style scoped>
.cm_list_container{
  width:100%;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  padding: 0 20px;
  height: 100%;
}
.cm_list_heading{
  height: 55px;
  border-bottom: 1px solid #4379D3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cm_list_heading>h3{
  font-size: 20px;
  font-weight: 500;
  color: #4379D3;
}
.cm_list_heading>span{
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_list_content_source{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cm_list_content>li{
  padding: 20px 0;
}
.cm_list_content>li>h3{
  font-size: 18px;
  font-weight: 600;
  color: #565656;
}
.cm_list_content_source>span{
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #A4A4A4;
}
.cm_list_pagination{
  width: 100%;
  display:flex;
  justify-content: center;
}

</style>